<template>
  <div>
    <section class="section">
      <div class="flex flex-col">
        <div class="title is-4 has-text-primary uppercase mb-4">
          Arranger la baie
        </div>
        <p>Cliquez sur un élément pour le sélectionner puis sur les flèches pour le déplacer.</p>
        <p>Commencez par placer vos éléments du bas en premier.</p>
        <div class="flex mt-8">
          <div class="flex flex-col justify-center mr-8">
            <b-button
              class="mb-4"
              type="is-info"
              icon-left="arrow-up"
              @click="moveUp"
            />
            <b-button
              type="is-info"
              icon-left="arrow-down"
              @click="moveDown"
            />
          </div>
          <TheBaie
            class="with-height"
            :elements="baieElements"
            :container="container"
            @selectElement="selectConfigurationElement"
          />
          <b-navbar
            fixed-bottom
            shadow
            class="pl-4 pr-4 pt-4"
          >
            <template slot="end">
              <b-button
                class="is-success mr-4"
                size="is-medium"
                tag="router-link"
                to="/uni-baies/resume"
              >
                Valider
              </b-button>
            </template>
          </b-navbar>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TheBaie from '@/components/TheBaie.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ArrangeBaie',
  components: { TheBaie },
  computed: mapGetters('configuration',
    ['container', 'baieElements', 'selectedConfigurationProduct']),
  beforeDestroy() {
    this.unselectConfigurationElement();
  },
  methods: {
    ...mapActions('configuration', ['selectConfigurationElement', 'moveProduct']),
    ...mapMutations('configuration', ['unselectConfigurationElement']),
    moveDown() {
      this.moveProduct(1);
    },
    moveUp() {
      this.moveProduct(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.with-height {
  height: 80vh;
  width: 1000px;
}
</style>
